// extracted by mini-css-extract-plugin
export default {"pageLayout":"PageLayout_pageLayout__RV72t","header":"PageLayout_header__ZInYM","mobile":"PageLayout_mobile__Cv4LJ","container":"PageLayout_container__BKpZx"};